import React, {FC} from 'react';

import {CtaButton} from '@optimaxdev/design-system';
import {Link} from 'react-router-dom';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {miniCartDrawerEvent} from 'desktopMiniCart/analytic/analytic';
import {getIsOutOfStock} from 'hooks/getQuoteItemsCart/stockAccumulation';

import {MiniCartPricesSummary} from './miniCartPricesSummary/miniCartPricesSummary';

import s from './miniCartBottom.scss';

type PropsType = {
    items?: QuoteItemV2[];
};

const createLinkRenderer = (path: string) => {
    const LinkRenderer = (props: Object) => <Link {...props} to={path} />;
    return LinkRenderer;
};

/**
 * cart drawer bottom part
 */
export const MiniCartBottom: FC<PropsType> = ({items}) => (
    <div className={s.totalWrapper}>
        <MiniCartPricesSummary />
        <div className={s.bottom}>
            <CtaButton
                isDisabled={getIsOutOfStock(items)}
                onClick={() => miniCartDrawerEvent('Secure Checkout')}
                renderAs={createLinkRenderer('/checkout/onepage')}
                type="button"
            >
                Secure Checkout
            </CtaButton>
        </div>
        <div className={s.couponInfo}>
            <Link
                className={s.reviewCart}
                onClick={() => miniCartDrawerEvent('Review cart')}
                to="/checkout/cart"
            >
                Review cart
            </Link>{' '}
            for coupons and payment options
        </div>
    </div>
);
